import React from 'react';
import { activity } from '@codametrix/ui-common';
import { userActivityFormatter } from './useractivity-timeline-formatter';
import { isIe11 } from '@braintree/browser-detection';
import {
  cqaActivityFormatter,
  systemActivityFormatter
} from './systemactivity-timeline-formatter';
import { UserActivityComment } from '../userActivityComment/userActivityComment';
import { cqaUserActivityFormatter, userActivityCommentFormatter } from './useractivityComment-timeline-formatter';


export type TimelineProps = {
  items: (CMxAPI.UserActivity | CMxAPI.SystemActivity | CQA.ActivityEntry | CMxAPI.UserActivityComment | CQA.CQAComment)[];
  enableUserActivityComments?:boolean;
  editable?:boolean
};

enum ActivityType {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
  CQA = 'CQA',
  USER_ACTIVITY_COMMENTS = 'USER_ACTIVITY_COMMENTS',
  CQA_CODER_COMMENT = 'CQA_CODER_COMMENT',
}

const Timeline: React.FC<TimelineProps> = ({ items: allItems, enableUserActivityComments,editable}) => {
  const [filter, setFilter] = React.useState<"comments" | "all">("all"); 
  const filteredSourceItems = React.useMemo(() => {
    if (filter === "all") return allItems;
    return allItems.filter((item: any) => {
      const type = item.activityType || item.type || "";
      return typeof type === "string" && (type === ActivityType.USER_ACTIVITY_COMMENTS || type === ActivityType.CQA_CODER_COMMENT);
    });
  }, [allItems, filter]);

  const raw = React.useMemo(
    () =>
      activity.convertActivityToTimeline(filteredSourceItems, {
        [ActivityType.USER]: userActivityFormatter,
        [ActivityType.SYSTEM]: systemActivityFormatter,
        [ActivityType.CQA]: cqaActivityFormatter,
        [ActivityType.USER_ACTIVITY_COMMENTS]: userActivityCommentFormatter,
        [ActivityType.CQA_CODER_COMMENT]: cqaUserActivityFormatter,
      }),
    [filteredSourceItems]
  );
    
  if (raw?.length === 0 && !enableUserActivityComments) {
    return <div className="empty-message">No activity.</div>;
  }

  const items = raw.map((item, itemIdx) => {
    const tiles = item.tiles.map((tile, idx) => {
      const subTitle = tile.subtitle ? (
        <p className="cmx-tile-subtitle">On {tile.subtitle}:</p>
      ) : (
        false
      );
      const titles = !tile.titles?.length
        ? false
        : tile.titles.map((title, titleIdx) => (
            <div key={titleIdx} className="cmx-tile-title">
              {title}
            </div>
          ));

      return (
        <div className="cmx-tile" key={idx}>
          <div className="cmx-tile-content">
            {subTitle}
            {titles}
          </div>
        </div>
      );
    });

    return (
      <div
        className="timeline-item"
        data-testid={`timeline-item-${itemIdx}`}
        key={itemIdx}>
        <div className="timeline-left">
          <a className="timeline-icon"></a>
        </div>
        <div className="timeline-content">{tiles}</div>
      </div>
    );
  });

  // Handle filter changes from Comment component
  const handleFilterChange = (selected: "comments" | "all") => {
    setFilter(selected);
  };

  return (
    <>
       {enableUserActivityComments && (
             <UserActivityComment
                onFilterChange={handleFilterChange}
                editable={editable}
             />
        )}
             
    <div className="cmx-timeline timeline">
      <div className="timeline-meta">
        {isIe11()
          ? 'All times listed in UTC'
          : 'All times listed are in your timezone'}
      </div>
      {items}
    </div>
    </>
  );
};
Timeline.displayName = 'Timeline';
export { Timeline };
